// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Lookup Component */
.data-grid-container {
  overflow: hidden;
  position: relative;
  max-height: 400px;
}

@media (max-width: 600px) {
  ids-layout-grid {
    --min-col-width: 0 !important;
  }
  .data-grid-container.has-search {
    max-height: calc(100dvh - 184px);
  }
  .data-grid-container {
    max-height: 100%;
    height: 100%;
  }
  .data-grid-parent-container {
    height: 100% !important;
  }
}
.data-grid-parent-container {
  overflow: auto;
}

ids-trigger-field::part(clearable-button) {
  margin-inline-end: -9px;
}

ids-trigger-field[compact]::part(clearable-button) {
  margin-inline-end: -2px;
}

.result-count {
  font-size: var(--ids-lookup-result-count-font-size);
  margin: var(--ids-lookup-result-count-margin);
  vertical-align: middle;
}

ids-trigger-button[slot=trigger-end] {
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-lookup/ids-lookup.scss"],"names":[],"mappings":"AAEA,yBAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE;IAEE,6BAAA;EAFF;EAKA;IACE,gCAAA;EAHF;EAMA;IACE,gBAAA;IACA,YAAA;EAJF;EAOA;IACE,uBAAA;EALF;AACF;AAQA;EACE,cAAA;AANF;;AASA;EACE,uBAAA;AANF;;AASA;EACE,uBAAA;AANF;;AASA;EACE,mDAAA;EACA,6CAAA;EACA,sBAAA;AANF;;AASA;EACE,wBAAA;AANF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n/* Ids Lookup Component */\n.data-grid-container {\n  overflow: hidden;\n  position: relative;\n  max-height: 400px;\n}\n\n@media (max-width: $breakpoint-sm) {\n  ids-layout-grid {\n    // Need important to override inline element styles\n    --min-col-width: 0 !important;\n  }\n\n  .data-grid-container.has-search {\n    max-height: calc(100dvh - 184px);\n  }\n\n  .data-grid-container {\n    max-height: 100%;\n    height: 100%;\n  }\n\n  .data-grid-parent-container  {\n    height: 100% !important;\n  }\n}\n\n.data-grid-parent-container {\n  overflow: auto;\n}\n\nids-trigger-field::part(clearable-button) {\n  margin-inline-end: -9px;\n}\n\nids-trigger-field[compact]::part(clearable-button) {\n  margin-inline-end: -2px;\n}\n\n.result-count {\n  font-size: var(--ids-lookup-result-count-font-size);\n  margin: var(--ids-lookup-result-count-margin);\n  vertical-align: middle;\n}\n\nids-trigger-button[slot=\"trigger-end\"] {\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
